/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Shot_Change_MarkersInputs */

const en_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No shot change markers found. Please run shot change detection from the Ai Tools menu first.`)
};

const fr_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun marqueur de changement de plan trouvé. Lancez d’abord la détection des changements de plan depuis le menu Outils IA.`)
};

const de_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Schusswechselmarkierungen gefunden. Bitte führen Sie zuerst die Schusswechselerkennung über das Menü „KI-Tools“ aus.`)
};

const it_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun indicatore di cambio di tiro trovato. Eseguire prima il rilevamento del cambio di tiro dal menu Strumenti Ai.`)
};

const ru_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркеры смены выстрела не обнаружены. Пожалуйста, сначала запустите обнаружение смены выстрела из меню «Инструменты ИИ».`)
};

const es_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron marcadores de cambio de disparo. Primero, ejecute la detección de cambio de disparo desde el menú Herramientas de IA.`)
};

const zh_cn2_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到射门变化标记。请先从AI工具菜单运行射门变化检测。`)
};

const ja_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットチェンジマーカーが見つかりません。まずはAiツールメニューからショットチェンジ検出を実行してください。`)
};

const hi_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई शॉट परिवर्तन मार्कर नहीं मिला। कृपया पहले एआई टूल्स मेनू से शॉट परिवर्तन पहचान चलाएँ।`)
};

const pt_pt2_no_shot_change_markers = /** @type {(inputs: No_Shot_Change_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum marcador de mudança de tacada encontrado. Execute primeiro a detecção de mudança de tacada no menu Ferramentas de IA.`)
};

/**
* | output |
* | --- |
* | "No shot change markers found. Please run shot change detection from the Ai Tools menu first." |
*
* @param {No_Shot_Change_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_shot_change_markers = /** @type {((inputs?: No_Shot_Change_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Shot_Change_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_shot_change_markers(inputs)
	if (locale === "de") return de_no_shot_change_markers(inputs)
	if (locale === "it") return it_no_shot_change_markers(inputs)
	if (locale === "ru") return ru_no_shot_change_markers(inputs)
	if (locale === "es") return es_no_shot_change_markers(inputs)
	if (locale === "zh-CN") return zh_cn2_no_shot_change_markers(inputs)
	if (locale === "ja") return ja_no_shot_change_markers(inputs)
	if (locale === "hi") return hi_no_shot_change_markers(inputs)
	if (locale === "pt-PT") return pt_pt2_no_shot_change_markers(inputs)
	return en_no_shot_change_markers(inputs)
});